import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";
import { deleteCodeLevel } from "../../../../../actions/Utilities/CodeLevel";

const useDeleteCodeLevel = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids) => deleteCodeLevel(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["GetCodeLevels"]);
      toast.fire(
        "Success",
        "Code Level has been deactivated successfully",
        "success"
      );
    },
    onError: () => {
      toast.fire(
        "Failed",
        "Server Error: Cannot deactivate Code Level",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteCodeLevel;
